import { render, staticRenderFns } from "./TakeDowns.vue?vue&type=template&id=7f9f2ccc"
import script from "./TakeDowns.vue?vue&type=script&lang=js"
export * from "./TakeDowns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports